// src/pages/dashboard/DashboardSupport.jsx
import React from 'react';

const DashboardSupport = () => {
  return (
    <div className="bg-[#0B3A32] p-6 rounded-xl shadow-lg max-w-2xl">
      <h2 className="text-xl font-semibold text-[#CE9242] mb-4">📩 Support & Help</h2>

      <p className="text-sm text-gray-300 mb-4">
        Facing an issue? Need help with your trading bot? Reach out to our team and we’ll assist you as fast as possible.
      </p>

      <form className="space-y-4 text-sm text-gray-200">
        <div>
          <label className="block mb-1 text-gray-400">Your Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            className="w-full bg-[#062925] p-2 rounded-md text-white border border-[#1a4c46]"
          />
        </div>

        <div>
          <label className="block mb-1 text-gray-400">Your Message</label>
          <textarea
            rows="4"
            placeholder="Describe your issue or question..."
            className="w-full bg-[#062925] p-2 rounded-md text-white border border-[#1a4c46]"
          />
        </div>

        <button
          type="submit"
          className="mt-2 px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-md"
        >
          Submit Request
        </button>
      </form>
    </div>
  );
};

export default DashboardSupport;
